import { Route, Routes } from 'react-router-dom';
import { TmsContextProvider } from '../tms/TmsContext';
import Account from './Account';
import Billing from './billing/Billing';
import CreateAccount from './create/CreateAccount';
import QuickProvisionAccount from './create/QuickProvisionAccount';
import AccountDetail from './detail/AccountDetail';
import { AccountFraudDetail } from './fraud/AccountFraudDetail';
import { AccountMemoDetail } from './memos/AccountMemoDetail';
import Authorisations from './authorisations/Authorisations';
import { RegularPayments } from './regular-payments/RegularPayments';
import AccountSearch from './search/AccountSearch';
import Transactions from './transactions/Transactions';
import AccountInterestDetails from './rate-history/InterestDetails';
import { Bacs } from './regular-payments/bacs/Bacs';
import { Report } from './regular-payments/bacs/Report';
import { AccountContextProvider } from './AccountContext';
import AccountState from './account-state/AccountState';
import PayDownPlan from './pay-down-plan/PayDownPlan';

export function Accounts() {
  return (
    <Routes>
      <Route path="/" element={<AccountSearch />} />
      <Route
        path="/create"
        element={
          <TmsContextProvider>
            <CreateAccount />
          </TmsContextProvider>
        }
      />
      <Route path="/quick-provision" element={<QuickProvisionAccount />} />

      <Route
        path="/:accountId/*"
        element={
          <AccountContextProvider>
            <Account />
          </AccountContextProvider>
        }>
        <Route path="summary" element={<AccountDetail />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="billing" element={<Billing />} />
        <Route path="authorisations" element={<Authorisations />} />
        <Route path="memos" element={<AccountMemoDetail />} />
        <Route path="fraud" element={<AccountFraudDetail />} />
        <Route path="account-state" element={<AccountState />} />
        <Route path="regular-payments" element={<RegularPayments />} />
        <Route path="bacs" element={<Bacs />} />
        <Route path="rate-history" element={<AccountInterestDetails />} />
        <Route path="reports/:id" element={<Report />} />
        <Route path="pay-down-plan" element={<PayDownPlan />} />
      </Route>
    </Routes>
  );
}
